/**
 * @author: dwi.setiyadi@gmail.com
*/

import React from 'react';

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  // {
  //   path: '/',
  //   exact: true,
  //   name: 'Home',
  // },
  {
    path: '/roles/permission/role',
    exact: true,
    name: 'Permission Role',
    component: React.lazy(() => import('./views/PermissionRole')),
  },
];

export default routes;
